import axios from "axios";
import React, { useState } from "react";

export default function TransactionRow({ pm }) {
  const [customerData, setcustomerData] = useState(null);
  const getCustomer = async (customer) => {
    try {
      let res = await axios.get(`/api/stripe/customer/${customer}`);
      if (res.data.success) {
        setcustomerData(res.data.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };
  return (
    <tr key={pm.id}>
      <td> {new Date(pm.available_on * 1000).toLocaleDateString()}</td>
      <td>{pm.description ? pm.description : pm.reporting_category}</td>
      <td>{pm.amount / 100}</td>
      <td>{pm.fee / 100}</td>
      <td className="fw-6">{pm.net / 100}</td>
      <td>
        {pm.invoice ? (
          <a target="_blank" rel="noreferrer" href={pm.invoice.receipt}>
            Link
          </a>
        ) : null}
      </td>
      <td>
        {pm.invoice ? (
          <span
            className="pointer"
            onClick={() => getCustomer(pm.invoice?.customer)}
          >
            {pm.invoice?.customer}
          </span>
        ) : null}
        {customerData && (
          <div className="mt-24">
            <p>{customerData.name}</p>
            <p>{customerData.street}</p>
            <p>
              {customerData.location?.city}, {customerData.location?.state},{" "}
              {customerData.location?.country}, {customerData.location?.pincode}
            </p>
            <p>Tax ID: {customerData.tax}</p>
          </div>
        )}
      </td>
    </tr>
  );
}
